import { render } from "./PayIcon.vue?vue&type=template&id=eb8f3b12&scoped=true"
import script from "./PayIcon.vue?vue&type=script&lang=js"
export * from "./PayIcon.vue?vue&type=script&lang=js"

import "./PayIcon.vue?vue&type=style&index=0&id=eb8f3b12&scoped=true&lang=less"

import exportComponent from "D:\\work\\sckj\\tipian\\vue\\tipian_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eb8f3b12"]])

export default __exports__